import { useElementSize } from '@custom-react-hooks/use-element-size';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Stack, Typography, useTheme, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Administration from './administration';

const AdministrationPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [containerRef, containerSize] = useElementSize();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      ref={containerRef}
      sx={{
        height: { xs: 'auto', md: '100%' },
        p: { xs: 1.5, sm: 3 },
        pt: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        overflow: { xs: 'visible', md: 'hidden' },
      }}
    >
      {/* Header section with back button and title */}
      <Stack direction="row" spacing={1.5} alignItems="center">
        <IconButton
          onClick={() => navigate('/dashboard')}
          sx={{
            bgcolor: 'rgba(255, 255, 255, 0.4)',
            border: 1,
            borderColor: 'divider',
            backdropFilter: 'blur(10px)',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.6)',
              borderColor: theme.palette.secondary.main,
            },
            transition: 'all 0.2s ease',
          }}
        >
          <ArrowBackIcon sx={{ color: 'text.primary', fontSize: 18 }} />
        </IconButton>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800, color: 'text.primary' }}>
            System Administration
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            Manage entity definitions, system-wide settings, and tenant permissions.
          </Typography>
        </Box>
      </Stack>

      {/* Main glassmorphism card containing the Admin component */}
      <Box
        sx={{
          flexGrow: 1,
          minHeight: { xs: 500, md: 0 },
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(10px)',
          borderRadius: '24px',
          border: 1,
          borderColor: 'divider',
          overflow: 'hidden',
          p: 2.5,
        }}
      >
        <Administration maxHeight={containerSize.height > 0 ? (isMobile ? 550 : containerSize.height - 110) : 550} />
      </Box>
    </Box>
  );
};

export default AdministrationPage;
